import { Box, Card, CardContent, CircularProgress, Stack, Tab, Tabs } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { ContactContext } from "../../contact/ContactContext";
import OrdersFilter from "./orders/OrdersFilter";
import OrdersTable from "./orders/OrdersTable";
import InvoicesFilter from "./invoices/InvoicesFilter";
import InvoicesTable from "./invoices/InvoicesTable";
import { ContactOrder } from "./types";
import axios from "axios";

export default function OrdersAndInvoices({ type }: { type: "contact" | "company" }) {
  const { contact } = useContext(ContactContext);
  let location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const section = searchParams.get("section");
  const navigate = useNavigate();

  const displayOrders = !section || section === "orders";
  const displayInvoices = !displayOrders;

  const [orders, setOrders] = useState<ContactOrder[]>([]);
  const [orderFilterStatus, setOrderFilterStatus] = useState("All");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getOrders = async () => {
      setIsLoading(true);
      const url = type === "contact" ? "contacts/getcontactorders?contactid=" : "companies/getorders?companyid=";
      let { data } = await axios.get<ContactOrder[]>(`/api/clientphonebook/${url}${id}`);

      ///Doing this on the front end instead of the query in the backend in case a dev want to test that can just comment this line out
      data = data.filter((d) => d.orderNumber && !d.orderNumber?.toLowerCase()?.includes("test"));
      setOrders(data);
      setIsLoading(false);
    };
    getOrders();
  }, []);

  let ordersToDisplay = orders;
  if (orderFilterStatus !== "All") {
    ordersToDisplay = orders.filter((o) => o.orderStatus === orderFilterStatus);
  }

  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 3.5
          }}
        >
          <Tab label={`${orders.length} Orders`} value="orders" />
          <Box
            sx={{
              display: "flex",
              alignItems: "center"
            }}
          >
            {displayOrders && (
              <OrdersFilter
                statuses={["All", ...new Set(orders.filter((o) => Boolean(o.orderStatus)).map((o) => o.orderStatus!))]}
                selectedStatus={orderFilterStatus}
                onStatusChange={setOrderFilterStatus}
              />
            )}
            {displayInvoices && <InvoicesFilter />}
          </Box>
        </Box>
        {displayOrders && <OrdersTable orders={ordersToDisplay} />}
        {displayInvoices && <InvoicesTable />}
        {isLoading && (
          <Stack display="flex" justifyContent="center" alignItems="center" marginTop={2}>
            <CircularProgress />
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}
